/** Returned from `onSave` when save is deferred until moderation confirmation dialog is accepted. */
export const CHATBOT_SAVE_DEFERRED_FOR_MODERATION_CONFIRM = "__DEFERRED_MODERATION_CONFIRM__";
